import React from 'react';
import { Container } from './Container';
import { CTAButton } from './CTAButton';
import { Doodle } from './Doodle';
import { ProductMockup } from './ProductMockup';
import { TrustRow } from './TrustRow';
import { heroChips } from '../data/landing';
import { usePricing } from '../hooks/usePricing';
const chipTones = ['text-teal', 'text-sun', 'text-leaf', 'text-pink'];
export function Hero() {
  const {
    price,
    regularPrice
  } = usePricing();
  return <section id="inicio" aria-labelledby="hero-title" className="relative overflow-hidden bg-cream pb-12 pt-8 sm:pt-12 lg:pb-20 lg:pt-16" data-id="element-225" data-mp="127ec173d7daa">
      <Container data-id="element-226" data-mp="sai4b3laiv6s">
        <div className="grid gap-y-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-x-14" data-id="element-227" data-mp="s9zz3hgnh6mq">
          <div className="relative lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-228" data-mp="ncztf7npq5w5">
            <Doodle kind="rays" className="absolute -left-2 -top-6 hidden h-7 w-7 -rotate-12 sm:block" data-id="element-229" data-mp="3d1a8vl7kyddt" />
            <h1 id="hero-title" className="text-balance font-heading text-[2.4rem] font-black leading-[1.02] tracking-[-0.015em] text-navy sm:text-[3.4rem] lg:text-[4rem]" data-id="element-230" data-mp="382p91mw8pvpw">
              Todo tu mes de viandas. <span className="text-teal" data-id="element-231" data-mp="3o6amdlpjdov7">Resuelto.</span> Desde mañana.
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-navy-soft sm:text-lg" data-id="element-232" data-mp="399bcfr77pjxk">
              <strong className="font-semibold text-navy" data-id="element-233" data-mp="3e8ehhbn6zq5j">30 Días de Viandas Resueltas</strong> — el sistema práctico para organizar las viandas escolares sin improvisar cada mañana.
            </p>
            <p className="mt-3 max-w-xl text-base font-semibold text-navy sm:text-lg" data-id="element-234" data-mp="359t0hkxdcj6v">
              Plan + recetas + compras + freezer + Plan B.{' '}
              <span className="font-normal text-navy-soft" data-id="element-235" data-mp="2qi0mbc9b9b6q">Sin decidir cada noche. Sin empezar de cero.</span>
            </p>
          </div>

          <div className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-236" data-mp="2hix1o3uhwnq4">
            <ProductMockup eager className="mx-auto max-w-[540px]" data-id="element-237" data-mp="2lla5gmpombk9" />
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-238" data-mp="s1rqqjt21ys6">
            <ul className="flex flex-wrap gap-2" data-id="element-239" data-mp="s3ck463mvbog">
              {heroChips.map(({
              icon: Icon,
              title
            }, i) => <li key={title} className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-teal-soft bg-white px-3 py-1.5 text-sm font-semibold text-navy" data-id="element-240" data-mp="n98dxp26z7of" data-mpi={i}>
                  <Icon aria-hidden="true" strokeWidth={2.25} className={`h-4 w-4 ${chipTones[i % chipTones.length]}`} data-id="element-241" data-mp="1b1fd0vzaxsrj" />
                  {title}
                </li>)}
            </ul>

            <div className="mt-6 flex flex-wrap items-end gap-x-3 gap-y-1" data-id="element-242" data-mp="1126m6bzqgu9e">
              {regularPrice && <p className="pb-1.5 text-lg font-semibold text-navy-soft line-through decoration-pink decoration-2" data-id="element-243" data-mp="x030kujco9ae">{regularPrice}</p>}
              <p className="font-heading text-4xl font-black tracking-tight text-pink sm:text-[2.85rem]" data-id="element-244" data-mp="3lqm2jypo95ux">{price}</p>
              <p className="pb-1.5 text-sm font-medium text-navy-soft" data-id="element-245" data-mp="1x9kv8ohov8i9">Pago único · Acceso digital inmediato</p>
            </div>
            <CTAButton label="Quiero resolver las viandas" location="hero" fullWidth className="mt-4 sm:w-auto" data-id="element-246" data-mp="21by07aom32dz" />
            <TrustRow className="mt-4" data-id="element-247" data-mp="2697mwikm8zy4" />
          </div>
        </div>
      </Container>
    </section>;
}